// Compatibility hook kept so the GTM plugin remains unchanged. The anonymous
// Mixpanel service enforces consent at its own dispatch boundary.
export const syncMixpanelConsent = () => {};
